import React, { useState, useRef, useEffect } from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Link } from 'react-router-dom';

const ItemType = 'LIST_ITEM';

const DraggableItem = ({ id, name, index, moveItem, sequence }) => {
    const ref = useRef(null);
    const [, drag] = useDrag({
        type: ItemType,
        item: { id, index },
    });

    // Set up drop target
    const [, drop] = useDrop({
        accept: ItemType,
        hover(item) {
            if (item.index === index) return;

            moveItem(item.index, index);
            item.index = index;  // update the dragged item's index
        },
    });
    drag(drop(ref));
    return (
        <tr key={id} ref={ref} style={{ cursor: "grab" }}>
            <td>{index + 1}</td>
            <td>{sequence}</td>
            <td>{name}</td>
        </tr>
    );
};

const ReorderList = () => {
    const BASE_URL = process.env.REACT_APP_PP_URL;
    const [data, setData] = useState([]);
    const [filterData, setFilterData] = useState([...data]);

    const getList = async (url) => {
        const token = sessionStorage.getItem('tokenKey');
        try {
            if (url === "/admin/v1/category/parent-category-list-in-key-value") {
                const res = await fetch(`${BASE_URL}/admin/v1/category/parent-category-sequence-detail`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
                const getRes = await res.json();
                if (getRes.errorCode === 0) {
                    setData(() => getRes.responsePacket?.slice().sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((itm) => ({
                        label: itm.title,
                        key: itm.uuid,
                        value: itm.uuid,
                        sequenceNo: itm.sequenceNo,
                    })) || []);
                    setFilterData(() => getRes.responsePacket?.slice().sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((itm) => ({
                        label: itm.title,
                        key: itm.uuid,
                        value: itm.uuid,
                        sequenceNo: itm.sequenceNo,
                    })) || []);
                }
            } else if (url === "/admin/v1/banner/list") {
                const res = await fetch(`${BASE_URL}/admin/v1/banner/list-data/Active`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    }
                });
                const getRes = await res.json();
                if (getRes.errorCode === 0) {
                    setData(() => getRes.responsePacket?.slice()?.sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo)).map((itm) => ({
                        label: itm.title,
                        key: itm.uuid,
                        value: itm.uuid,
                        sequenceNo: itm.sequenceNo,
                    })) || []);
                    setFilterData(() => getRes.responsePacket?.slice().sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((itm) => ({
                        label: itm.title,
                        key: itm.uuid,
                        value: itm.uuid,
                        sequenceNo: itm.sequenceNo,
                    })) || []);
                };
            };
        } catch (e) {
            console.log(e, "error in list api")
        };
    };

    const [parentCatId, setParentCatId] = useState();
    const [showInput, setShowInput] = useState(false);

    const getSubCat = async (parentCategoryId) => {
        const token = sessionStorage.getItem('tokenKey');
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/category/sub-category-sequence-detail/${parentCategoryId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setData(() => getRes.responsePacket?.slice()?.sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo)).map((itm) => ({
                    label: itm.title,
                    key: itm.uuid,
                    value: itm.uuid,
                    sequenceNo: itm.sequenceNo,
                })) || []);
                setFilterData(() => getRes.responsePacket?.slice().sort((a, b) => Number(a.sequenceNo) - Number(b.sequenceNo))?.map((itm) => ({
                    label: itm.title,
                    key: itm.uuid,
                    value: itm.uuid,
                    sequenceNo: itm.sequenceNo,
                })) || []);
            }
        } catch (e) {
            console.log(e, "error in getSub");
        }
    };
    useEffect(() => {
        if (selectedOption === "Subcategory" && parentCatId) {
            getSubCat(parentCatId);
        };
    }, [parentCatId]);

    const handleSearchByName = (e) => {
        const get = e.target.value;
        const filter = data.filter((itm) =>
            itm.label.toLowerCase().includes(get.toLowerCase())
        );
        setFilterData(filter);
    };
    const handleSearchBySequence = (e) => {
        const filter = data.filter((itm) =>
            itm.sequenceNo.toString().includes(e.target.value)
        );
        setFilterData(filter);
    };

    const [selectedOption, setSelectedOption] = useState('');
    const [searchOrder, setSearchOrder] = useState('');
    const [searchName, setSearchName] = useState('');

    const moveItem = (fromIndex, toIndex) => {
        setData((prevItems) => {
            const updated = [...prevItems];
            const [moved] = updated.splice(fromIndex, 1);
            updated.splice(toIndex, 0, moved);
            return updated;
        });
        setFilterData((prevItems) => {
            const updated = [...prevItems];
            const [moved] = updated.splice(fromIndex, 1);
            updated.splice(toIndex, 0, moved);
            return updated;
        });
    };

    const [parentList, setParentList] = useState([]);

    const getParentCatList = async () => {
        try {
            const token = sessionStorage.getItem('tokenKey');
            const res = await fetch(`${BASE_URL}/admin/v1/category/parent-category-list-in-key-value`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setParentList(getRes.responsePacket);
            }
        } catch (e) {
            console.log(e, "error in getCategory Lis");
        }
    };

    useEffect(() => {
        if (selectedOption === "Category") {
            getList("/admin/v1/category/parent-category-list-in-key-value");
            setParentCatId('');
            setShowInput(false);
            setParentList([]);
        } else if (selectedOption === "Banner") {
            getList("/admin/v1/banner/list");
            setParentCatId('');
            setShowInput(false);
            setParentList([]);
        } else if (selectedOption === "Subcategory" && parentList?.length <= 0) {
            setShowInput(true);
            getParentCatList();
        }
    }, [selectedOption, parentCatId]);

    const postSequence = async () => {
        try {
            const token = sessionStorage.getItem('tokenKey');
            const payload = data.map((item, index) => ({
                id: item.key || item.value,
                sequenceNo: index + 1
            }));
            const res = await fetch(`${BASE_URL}/admin/v1/category/update-Cat-SubCat-Display-Ordering`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ catSubCatSequences: payload })
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                alert(getRes.message);
                if (selectedOption === "Category") {
                    getList("/admin/v1/category/parent-category-list-in-key-value");
                    setParentCatId('');
                    setShowInput(false);
                    setParentList([]);
                } else if (selectedOption === "Banner") {
                    getList("/admin/v1/banner/list");
                    setParentCatId('');
                    setShowInput(false);
                    setParentList([]);
                } else if (selectedOption === "Subcategory" && parentCatId) {
                    getSubCat(parentCatId);
                };
            }
        } catch (e) {
            console.log(e, "error in post sequence");
        }
    };

    useEffect(() => {
        const handleAutoScroll = (e) => {
            const scrollSpeed = 20;
            const edgeMargin = 100;
            const y = e.clientY;
            const windowHeight = window.innerHeight;
            if (y < edgeMargin) {
                window.scrollBy(0, -scrollSpeed);
            } else if (y > windowHeight - edgeMargin) {
                window.scrollBy(0, scrollSpeed);
            }
        };

        document.addEventListener("dragover", handleAutoScroll);
        return () => {
            document.removeEventListener("dragover", handleAutoScroll);
        };
    }, []);


    return (
        <>
            <DndProvider backend={HTML5Backend}>
                <div className="category">
                    <div className="row">
                        <div className="category" style={{ display: "block", width: "100%" }}>
                            <div className="category-nav">
                                <div className="category-text">
                                    <h4>Sequence List</h4>
                                </div>
                                <div className="category-btn">
                                    <Link>
                                        <button onClick={postSequence}>Submit</button>
                                    </Link>
                                </div>
                            </div>
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="reorder-container">
                    <h1 className="reorder-title">Reorder Navigation</h1>
                    <div className="reorder-select-wrapper">
                        <select
                            value={selectedOption}
                            onChange={e => setSelectedOption(e.target.value)}
                            className="reorder-select"
                            style={{ margin: 0 }}
                        >
                            <option>Select Module</option>
                            <option value="Category">Category</option>
                            <option value="Subcategory">Subcategory</option>
                            {/* <option value="Banner">Banner</option> */}
                        </select>
                        {selectedOption === "Subcategory" && showInput && parentList?.length > 0 && <select
                            value={parentCatId}
                            onChange={e => setParentCatId(e.target.value)}
                            className="reorder-select"
                            style={{ margin: 0 }}
                        >
                            <option hidden>Select Category</option>
                            {
                                parentList?.map((item) => {
                                    return (
                                        <option value={item.value}>{item.label}</option>
                                    )
                                })
                            }
                        </select>}
                        <button
                            onClick={() => { setSelectedOption(''); setData([]); setFilterData([]) }}
                            className="reorder-clear"
                        >
                            ✕
                        </button>
                    </div>

                    <div className="reorder-table-wrapper">
                        <h2 className="reorder-table-title">Sorting Table</h2>
                        <table className="reorder-table">
                            <thead>
                                <tr>
                                    <th>Sr.No</th>
                                    <th>
                                        <input
                                            type="text"
                                            placeholder="Current Order No"
                                            className="reorder-input"
                                            value={searchOrder}
                                            onChange={e => { setSearchOrder(e.target.value); handleSearchBySequence(e) }}
                                        />
                                    </th>
                                    <th>
                                        <input
                                            type="text"
                                            placeholder="Name"
                                            className="reorder-input"
                                            value={searchName}
                                            onChange={e => { setSearchName(e.target.value); handleSearchByName(e) }}
                                        />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {filterData.map((item, index) => (
                                    <DraggableItem
                                        key={item.value}
                                        id={item.key}
                                        name={item.label}
                                        index={index}
                                        moveItem={moveItem}
                                        sequence={item.sequenceNo}
                                    />
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </DndProvider>
        </>
    );
};

export default ReorderList;